import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "topbar" }
const _hoisted_2 = { class: "topbar-logo" }
const _hoisted_3 = { class: "topbar-nav" }
const _hoisted_4 = { class: "topbar-actions" }

import { useAuthStore } from "@/stores/auth";
import { useThemeStore } from "@/stores/theme";
import { useRouter } from "vue-router";
import BaseIcon from "@/components/ui/BaseIcon.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const authStore = useAuthStore();
const themeStore = useThemeStore();
const router = useRouter();

function handleLogout() {
  authStore.logout();
  router.push("/signin");
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_RouterLink, {
      to: "/dashboard",
      class: "topbar-brand"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(BaseIcon, {
            name: "layers",
            size: 18,
            "stroke-width": 2.5
          })
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("span", { class: "topbar-brand-name" }, "Pulse", -1))
      ]),
      _: 1
    }),
    _createElementVNode("nav", _hoisted_3, [
      _createVNode(_component_RouterLink, {
        to: "/dashboard",
        class: "nav-link"
      }, {
        default: _withCtx(() => [
          _createVNode(BaseIcon, {
            name: "grid",
            size: 15
          }),
          _cache[2] || (_cache[2] = _createElementVNode("span", null, "Dashboard", -1))
        ]),
        _: 1
      }),
      _createVNode(_component_RouterLink, {
        to: "/users",
        class: "nav-link"
      }, {
        default: _withCtx(() => [
          _createVNode(BaseIcon, {
            name: "users",
            size: 15
          }),
          _cache[3] || (_cache[3] = _createElementVNode("span", null, "Users", -1))
        ]),
        _: 1
      })
    ]),
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "topbar-spacer" }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        class: "icon-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(themeStore).toggleTheme && _unref(themeStore).toggleTheme(...args)))
      }, [
        _createVNode(BaseIcon, {
          name: _unref(themeStore).isDark ? 'moon' : 'sun',
          size: 17
        }, null, 8, ["name"])
      ]),
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "topbar-divider" }, null, -1)),
      _createElementVNode("button", {
        class: "logout-btn",
        onClick: handleLogout
      }, [
        _createVNode(BaseIcon, {
          name: "log-out",
          size: 15
        }),
        _cache[4] || (_cache[4] = _createElementVNode("span", null, "Logout", -1))
      ])
    ])
  ]))
}
}

})